export const addUser = "ADD_USER";
export const removeUser = "REMOVE_USER";
export const addMuseum = "ADD_MUSEUM";
export const removeMuseum = "REMOVE_MUSEUM";
export const authorised = "CHANGE_AUTHENTICATION";
export const addUUID = "ADD_UUID";
export const removeUUID = "REMOVE_UUID";
export const addAccessToken = "ADD_ACCESS_TOKEN";
export const removeAccessToken = "REMOVE_ACCESS_TOKEN";
export const addLoaderLoading = "ADD_LOADER_LOADING";
export const removeLoaderLoading = "REMOVE_LOADER_LOADING";
